const { useState } = require("react")

const useForm = (send, config) => {
    /** Form input */
    const [refs, setRefs] = useState({})

    /** Form boolean */
    const [isLoading, setIsLoading] = useState(false)
    const [isSubmitted, setIsSubmitted] = useState(false)

    /** Form error */
    const [errorMessage, setErrorMessage] = useState(null)

    const register = (name, ref) => { 

        setRefs(refs => ({...refs, [name]:ref}))
    }

    const deregister = (name) => {
        const temp = refs
        delete temp[name]
        setRefs({...temp})
    }

    const getValues = async () => {
        try {
            let values = {}
            for (const name in refs) {
                values[name] = await refs[name].current.value()
            }
            return values
        } catch (error) {
            throw error
        }
    }

    const getValid = async () => {
        try {
            let valid = true
            for (const name in refs) {
                valid =  refs[name].current.isValid() && valid 

            }
            return valid
        } catch (error) {
            throw error
        }
    }

    const onSubmit = async () => {
        try {
            setIsLoading(true)
            const valid = await getValid()
            if (!valid) {
                setErrorMessage("submitErrorMissing")
            } else {
                const values = await getValues()
                await send({...values, ...config})
                setIsSubmitted(true)
            }
            setIsLoading(false)
        } catch (error) {
            setIsLoading(false)
            setErrorMessage("submitErrorGeneral")
        }
    }

    return {
        isLoading,
        isSubmitted,
        errorMessage,
        onSubmit,
        bind: {
            register,
            deregister
        },
        refs
    }
}

export default useForm;